import { Grid, Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import NumberChip from "./components/NumberChip";
import RedirectsSelector from "./components/RedirectsSelector";

// ----------------------------------------------------------------------

export const RedirectsParameter = () => {
	const { translate } = useLocales();

	return (
		<Stack flexDirection={"row"} alignItems={"flex-start"} mt={3}>
			<NumberChip value='2' />
			<Stack sx={{ flex: 1 }} ml={2}>
				<Typography variant='subtitle2' color='text.primary'>
					{translate("url_panel.redirect_url")}
				</Typography>

				<Grid container justifyContent={"space-between"} rowSpacing={{ xs: 2, sm: 0 }}>
					<Grid item xs={12} sm={6}>
						<Typography variant='body2' color='text.secondary'>
							{translate("url_panel.redirect_url_des")}
						</Typography>
					</Grid>
					<Grid item xs={12} sm={6} justifyItems={{ xs: "flex-start", sm: "flex-end" }}>
						<RedirectsSelector />
					</Grid>
				</Grid>
			</Stack>
		</Stack>
	);
};

export default RedirectsParameter;
